// import awsExports from 'src/assets/amplify/aws-exports.json';

// .env에 있는 Django 엔드포인트 사용
export const getDjangoEndpoint = () => {
  return process.env.REACT_APP_ENDPOINT;
};
